<template>
  <div class="bbe-search-filter" v-click-outside="closeSearchSettings" @click.stop.prevent>
    <div class="bbe-search-filter__header">{{searchByFilterName}}</div>
    <div class="bbe-search-filter__item bbe-search-filter__item_box"
         @click="setValueCheckbox(option)"
         v-for="option in searchFilterCheckBox" :key="option.id">
      <checkbox @checkboxChange="checkedOption" :section="option" :value="option.checked"/>
      <span class="bbe-search-filter__text">{{option.name}}</span>
    </div>
    <div class="bbe-search-filter__item bbe-search-filter__item_radio">
      <EmailRadioInput @checked="setOptionRadio" :options="searchFilterRadioInput"/>
    </div>
  </div>
</template>

<script>
import checkbox from '@/components/Main/FormsElements/checkbox'
import EmailRadioInput from '@/components/Main/FormsElements/EmailRadioInput'
import templateSettingsApi from '@/api/TemplateSettings/api'
import {cloneDeep} from 'lodash'

export default {
  name: 'SearchFilter',
  components: {EmailRadioInput, checkbox},
  data () {
    return {
      searchByFilterName: 'filter',
      searchFilterCheckBox: [
        {id: 1, name: 'Header template', checked: false},
        {id: 2, name: 'Body template', checked: false}
      ],
      searchFilterRadioInput: [
        {id: 1, title: 'Partial match', checked: false},
        {id: 2, title: 'Full match', checked: false}
      ]
    }
  },
  computed: {
    searchStore: {
      get: function () {
        return this.$store.getters.search
      },
      set: function (data) {
        this.$store.dispatch('setSearch', data)
      }
    },
    templateSetting: {
      get: function () {
        return this.$store.getters.templateSetting
      },
      set: function (data) {
        this.$store.dispatch('setTemplateSetting', data)
      }
    }
  },
  methods: {
    checkedOption (data, option, name) {
      name.checked = data
    },
    setValueCheckbox (option) {
      this.$set(option, 'checked', !option.checked)
      this.updateTemplateSettings()
    },
    setOptionRadio (optionId) {
      this.searchFilterRadioInput.forEach(option => {
        option.checked = optionId === option.id
      })
      this.updateTemplateSettings()
    },
    getTemplateSettings () {
      templateSettingsApi.getTemplateSettings()
        .then(resp => {
          this.updateSearchFilterCheckBox(resp.data.templateName, resp.data.templateContent)
          this.updateSearchFilterRadioInput(resp.data.substring)
        })
        .catch(err => {
          console.error(err)
        })
    },
    templateSettingsBody () {
      this.searchFilterCheckBox.forEach(option => {
        option.id === 1
          ? this.templateSetting.templateName = option.checked
          : this.templateSetting.templateContent = option.checked
      })
      this.searchFilterRadioInput.forEach(option => (this.templateSetting.substring = !option.checked))
    },
    updateTemplateSettings () {
      this.templateSettingsBody()
      templateSettingsApi.updateTemplateSettings(this.templateSetting)
        .then(resp => {
          this.templateSetting = resp.data
          this.updateSearchFilterCheckBox(resp.data.templateName, resp.data.templateContent)
          this.updateSearchFilterRadioInput(resp.data.substring)
          if (!this.searchStore.keywordTemplates) return
          this.searchStore = cloneDeep(this.searchStore)
        })
        .catch(err => {
          console.error(err)
        })
    },
    updateSearchFilterCheckBox (templateName, templateContent) {
      this.searchFilterCheckBox.forEach(option => (option.checked = option.id === 1 ? templateName : templateContent))
    },
    updateSearchFilterRadioInput (substring) {
      const id = substring ? 1 : 2
      this.searchFilterRadioInput = this.searchFilterRadioInput.map(option => {
        option.checked = id === option.id
        return option
      })
    },
    closeSearchSettings () {
      this.$emit('close')
    }
  },
  beforeMount () {
    if (Object.keys(this.templateSetting).length === 0) {
      this.getTemplateSettings()
    } else {
      this.updateSearchFilterCheckBox(this.templateSetting.templateName, this.templateSetting.templateContent)
      this.updateSearchFilterRadioInput(this.templateSetting.substring)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-search-filter {
  position: fixed;
  top: 55px;
  left: 585px;
  width: 207px;
  box-shadow: 0 0 15px rgba($color-black, 0.08);
  border-radius: 6px;
  background-color: $color-white;
  padding: 12px;
  z-index: 222;

  &__header {
    text-align: center;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-transform: capitalize;
  }

  &__item {
    font-size: 13px;
    line-height: 16px;
    color: $color-black;
    transition: 0.3s;
    display: flex;
    align-items: center;

    &_box {
      padding: 13px 0 12px;
      border-bottom: 1px solid $color-alabaster;

      &:hover {
        color: $color-accent;
      }
    }

    &_radio {
      padding-top: 13px;
    }
  }

  &__text {
    margin-left: 8px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/SearchFilter/SearchFilter.vue